<template>
  <v-date-picker
    v-model="temp.value"
    :inputDebounce="inputDebounce"
    :masks="masks"
    :max-date="maxDate"
    :popover="popover"
    @input="input"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <input
        type="text"
        :value="inputValue"
        placeholder="日付を選択してください"
        :disabled="disabled"
        :class="cssClass"
        v-on="inputEvents"
      />
    </template>
  </v-date-picker>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    maxDate: {
      type: Date,
      required: false,
      default() {
        return new Date();
      }
    },
    size: {
      type: String,
      required: false
    },
    value: {
      type: Date,
      required: false
    }
  },
  data() {
    return {
      inputDebounce: 300,
      masks: {
        input: 'YYYY.MM.DD',
        title: 'YYYY年 M月'
      },
      popover: {
        transition: 'fade',
        visibility: 'focus'
      },
      temp: {
        value: null
      }
    };
  },
  computed: {
    cssClass() {
      return {
        'c-input': true,
        ['c-input--' + this.size]: this.size
      };
    }
  },
  watch: {
    value: {
      handler(value) {
        this.temp.value = value ? new Date(value) : null;
      },
      immediate: true
    }
  },
  methods: {
    input() {
      this.$emit('input', this.temp.value);
    }
  }
};
</script>
